/**
 * MAP (in-file navigation graph — keep in sync with the code):
 *   role:      util — «UI nuova» explained-disabled state of the classic
 *              choice controls (BbCheckbox, BbRadio, BbToggle; spec
 *              docs/ui-nuova/components/fields.md §6-7, owner rule 2026-10-09:
 *              the user must always know why a control does not work).
 *   behaviour: isNuova(owner) — service:ui (optional lookup, beebee-base) says
 *              the nuova UI is on. disabledTabIndex(disabled, explained) —
 *              a disabled control is out of the tab order ('-1', classic
 *              unchanged) unless it is EXPLAINED: nuova AND a @disabledReason
 *              passed, then it stays a tab stop ('0') so its aria-disabled
 *              state and reason are reachable. Without a reason the nuova
 *              behaves like the classic (= NvSettingsSwitchRow: no reason,
 *              natively disabled) — a focus stop that says nothing on press
 *              would be a silent guard. explainDisabled
 *              (owner, reason, host) — the reason as a notify.info toast (6s),
 *              the same reason not repeated within 2.5s (= nv-disabled-reason
 *              of beebee-base).
 *   users:     bb-checkbox.js, bb-radio.js, bb-toggle.js
 *   gotchas:   classic behaviour must not change: every nuova branch is behind
 *              isNuova(owner) === true.
 */
const REPEAT_MS = 2500;
const REASON_MS = 6000;
const lastShown = new WeakMap();
function isNuova(owner) {
  return owner?.lookup?.('service:ui')?.isNuova === true;
}

// `explained` = nuova AND a reason to tell (the components' disabledReason getter)
function disabledTabIndex(disabled, explained) {
  return disabled && !explained ? '-1' : '0';
}
function explainDisabled(owner, reason, host) {
  if (!reason) return;
  const now = Date.now();
  if (now - (lastShown.get(host) || 0) < REPEAT_MS) return;
  lastShown.set(host, now);
  owner?.lookup?.('service:notify')?.info?.(String(reason), {
    closeAfter: REASON_MS
  });
}

export { disabledTabIndex as d, explainDisabled as e, isNuova as i };
//# sourceMappingURL=nuova-disabled-e66e2b71.js.map
